/**
 * @generated SignedSource<<29ee6c81be1c2426902d1c8cf18e3036>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PlacementOutputFileType = "ONE_FILE_FOR_ALL_DESIGN" | "ONE_FILE_FOR_EACH_DESIGN";
export type placementQuery$variables = {
  id: string;
};
export type placementQuery$data = {
  readonly placementOutput: {
    readonly dpi: number;
    readonly heightCM: number;
    readonly id: string;
    readonly isEnabled: boolean;
    readonly jsonArea: string | null;
    readonly modelID: number;
    readonly name: string;
    readonly placementOutputAreaItems: ReadonlyArray<{
      readonly areaID: number;
      readonly colorID: number;
      readonly json: string;
      readonly placementOutputAreaItemID: number;
      readonly sideID: number;
      readonly svg: string;
    }>;
    readonly placementOutputID: number;
    readonly placementOutputItems: ReadonlyArray<{
      readonly json: string;
      readonly placementOutputItemID: number;
    }>;
    readonly placementOutputLayers: ReadonlyArray<{
      readonly colorID: number;
      readonly fileID: any | null;
      readonly fileObjectID: number;
      readonly jsonArea: string | null;
      readonly placementOutputLayerID: number;
    }>;
    readonly settings: {
      readonly backgroundAsFillBackgroundTool: boolean;
      readonly placementOutputFileType: PlacementOutputFileType;
    } | null;
    readonly templateFileID: any | null;
    readonly templateFileObjectID: number | null;
    readonly widthCM: number;
  } | null;
};
export type placementQuery = {
  response: placementQuery$data;
  variables: placementQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jsonArea",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "colorID",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "json",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "PlacementOutput",
    "kind": "LinkedField",
    "name": "placementOutput",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "modelID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "widthCM",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "heightCM",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dpi",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isEnabled",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "templateFileObjectID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "templateFileID",
        "storageKey": null
      },
      (v1/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "placementOutputID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PlacementOutputAreaItem",
        "kind": "LinkedField",
        "name": "placementOutputAreaItems",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "placementOutputAreaItemID",
            "storageKey": null
          },
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sideID",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "areaID",
            "storageKey": null
          },
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "svg",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PlacementOutputItem",
        "kind": "LinkedField",
        "name": "placementOutputItems",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "placementOutputItemID",
            "storageKey": null
          },
          (v3/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PlacementOutputLayer",
        "kind": "LinkedField",
        "name": "placementOutputLayers",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "placementOutputLayerID",
            "storageKey": null
          },
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fileID",
            "storageKey": null
          },
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fileObjectID",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PlacementSettings",
        "kind": "LinkedField",
        "name": "settings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "placementOutputFileType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "backgroundAsFillBackgroundTool",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "placementQuery",
    "selections": (v4/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "placementQuery",
    "selections": (v4/*:: as any*/)
  },
  "params": {
    "cacheID": "681ba47f1943e68a54dc2c018e4b3ae6",
    "id": null,
    "metadata": {},
    "name": "placementQuery",
    "operationKind": "query",
    "text": "query placementQuery(\n  $id: ID!\n) {\n  placementOutput(id: $id) {\n    id\n    modelID\n    widthCM\n    heightCM\n    dpi\n    isEnabled\n    templateFileObjectID\n    templateFileID\n    jsonArea\n    name\n    placementOutputID\n    placementOutputAreaItems {\n      placementOutputAreaItemID\n      colorID\n      sideID\n      areaID\n      json\n      svg\n    }\n    placementOutputItems {\n      placementOutputItemID\n      json\n    }\n    placementOutputLayers {\n      placementOutputLayerID\n      colorID\n      fileID\n      jsonArea\n      fileObjectID\n    }\n    settings {\n      placementOutputFileType\n      backgroundAsFillBackgroundTool\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f71911358cecd2686f6588eb87ece9b5";

export default node;
